import { useState, useEffect } from "react";
import { useLayout } from "../../../contexts/LayoutContext";
import {
  Code,
  Layers,
  BookOpen,
  MapPin,
  Award,
  Server,
  Monitor,
  User,
  CircleAlert,
  Radio,
  File,
  Shield,
  Hash,
  AtSign,
  DollarSign,
  Lock,
  TriangleAlert,
  Building2,
  Calendar,
  Zap,
  Flag,
  Wifi,
  HardDrive,
  Briefcase,
  Building,
  Info,
  Tag,
  Activity,
  Link,
  FileText,
  GraduationCap,
  Skull,
  Wrench,
  Search as SearchIcon,
  Cpu,
  Share2,
  Package,
  Fingerprint,
  Crosshair,
  Flame,
  Target,
  GitCompare,
  OctagonX,
  Text,
  CircleCheck,
  Mail,
  Factory,
  UserCog,
  UserCheck,
  CircleHelp,
  ExternalLink,
  FileSearch,
  ShieldAlert,
  Ruler,
  ScrollText,
  Satellite,
  ShieldCheck,
  Clock,
  Library,
  Swords,
  BookMarked,
  PieChart,
  Landmark,
  CalendarClock,
  Map as MapIcon,
  Star,
  Waypoints,
  Globe,
} from "lucide-react";

// Full icon map for sidebar favorites (mirrors MainGraph ICON_MAP exactly)
export const SIDEBAR_ICON_MAP = {
  SOFTWARE: Code,
  CMS: Layers,
  LEDGER: BookOpen,
  LOCATION: MapPin,
  CERTIFICATE: Award,
  WEBHOST: Server,
  STATE: MapIcon,
  OS: Monitor,
  BLACKLIST: OctagonX,
  DESCRIPTION: Text,
  ASN: Share2,
  SERVER_SERVICE: Cpu,
  PERSON: User,
  CVE: CircleAlert,
  CAMPAIGN: Radio,
  TITLE: CircleCheck,
  COURT_FILING: File,
  DOMAIN_CERTIFICATE: Shield,
  SERIAL_NUMBER: Hash,
  SOCIAL_MEDIA: AtSign,
  WEBSITE: Globe,
  CRYPTO: DollarSign,
  JARM: Lock,
  SEVERITY: TriangleAlert,
  CITY: Building2,
  DATE: Calendar,
  DATETIME: CalendarClock,
  CURRENCY: DollarSign,
  DOMAIN_SCANNED: SearchIcon,
  ACTION: Zap,
  COUNTRY: Flag,
  RANK: Star,
  SCORE: Star,
  POSTCODE: Mail,
  INDUSTRY: Factory,
  IP_ADDRESS: Wifi,
  SERVER: HardDrive,
  OCCUPATION: Briefcase,
  COMPANY: Building,
  EMPLOYEE: UserCog,
  OWNER: UserCheck,
  REASON: CircleHelp,
  INFO: Info,
  DOCKET_NUMBER: Hash,
  REFERENCE_LINK: ExternalLink,
  NAME: Tag,
  STATUS: Activity,
  SIMILAR: GitCompare,
  URL: Link,
  DOCUMENT: FileText,
  SCHOOL: GraduationCap,
  WORKED_AT: Building2,
  SANCTION_LOOKUP_NAME: FileSearch,
  SANCTION_ENTITY: ShieldAlert,
  SIZE: Ruler,
  BILL_OF_LADING: ScrollText,
  BoL: ScrollText,
  CONTAINER: Package,
  ALIAS: Fingerprint,
  ALIENVAULT_OTX: Satellite,
  COUNTER_OPERATION: ShieldCheck,
  FIRST_SEEN_DATE: Clock,
  INFORMATION_SOURCE: Library,
  MITRE_ATTACK: Crosshair,
  MOTIVATION: Flame,
  OPERATION: Swords,
  PLAYBOOK: BookMarked,
  SECTOR: PieChart,
  SPONSOR: Landmark,
  TARGET_COUNTRY: Target,
  THREAT_ACTOR: Skull,
  TOOL: Wrench,
};
export const sidebarIcon = (key) => SIDEBAR_ICON_MAP[key] || Waypoints;

// Type colors for sidebar (matches dark theme from MainGraph)
export const SIDEBAR_TYPE_COLORS = {
  PERSON: "rgba(59,130,246,0.85)",
  EMPLOYEE: "rgba(59,130,246,0.85)",
  OWNER: "rgba(96,165,250,0.85)",
  NAME: "rgba(59,130,246,0.70)",
  TITLE: "rgba(129,140,248,0.85)",
  COMPANY: "rgba(168,85,247,0.85)",
  INDUSTRY: "rgba(245,158,11,0.85)",
  OCCUPATION: "rgba(34,197,94,0.80)",
  LOCATION: "rgba(239,68,68,0.80)",
  CITY: "rgba(248,113,113,0.80)",
  STATE: "rgba(252,165,165,0.75)",
  COUNTRY: "rgba(220,38,38,0.80)",
  POSTCODE: "rgba(251,146,60,0.80)",
  WEBSITE: "rgba(6,182,212,0.85)",
  URL: "rgba(6,182,212,0.85)",
  REFERENCE_LINK: "rgba(34,211,238,0.80)",
  DOMAIN_SCANNED: "rgba(14,165,233,0.85)",
  IP_ADDRESS: "rgba(56,189,248,0.85)",
  ASN: "rgba(2,132,199,0.85)",
  WEBHOST: "rgba(8,145,178,0.85)",
  SERVER: "rgba(100,116,139,0.80)",
  SERVER_SERVICE: "rgba(148,163,184,0.80)",
  SOCIAL_MEDIA: "rgba(236,72,153,0.85)",
  JARM: "rgba(139,92,246,0.80)",
  CVE: "rgba(239,68,68,0.85)",
  SEVERITY: "rgba(245,158,11,0.90)",
  BLACKLIST: "rgba(220,38,38,0.85)",
  CAMPAIGN: "rgba(244,63,94,0.85)",
  SANCTION_LOOKUP_NAME: "rgba(244,63,94,0.85)",
  SANCTION_ENTITY: "rgba(244,63,94,0.85)",
  CERTIFICATE: "rgba(16,185,129,0.85)",
  DOMAIN_CERTIFICATE: "rgba(52,211,153,0.85)",
  CRYPTO: "rgba(245,158,11,0.85)",
  SERIAL_NUMBER: "rgba(148,163,184,0.80)",
  SOFTWARE: "rgba(129,140,248,0.85)",
  CMS: "rgba(99,102,241,0.80)",
  OS: "rgba(129,140,248,0.70)",
  DOCUMENT: "rgba(148,163,184,0.80)",
  ALIAS: "rgba(168,85,247,0.80)",
  SCHOOL: "rgba(129,140,248,0.85)",
  ACTION: "rgba(245,158,11,0.85)",
  TOOL: "rgba(245,158,11,0.85)",
  THREAT_ACTOR: "rgba(239,68,68,0.85)",
  MOTIVATION: "rgba(244,63,94,0.80)",
  MITRE_ATTACK: "rgba(239,68,68,0.80)",
  SECTOR: "rgba(34,197,94,0.80)",
  SPONSOR: "rgba(168,85,247,0.80)",
  CONTAINER: "rgba(148,163,184,0.80)",
};
export const sidebarTypeColor = (key) =>
  SIDEBAR_TYPE_COLORS[key] || "rgba(14,165,233,0.75)";

/* ═══════════════════════════════════════════
   Shared portal-target hook (dual-slot aware)
   Tries the navbar slot first when sidebar is
   closed, otherwise the sidebar slot. Polls
   continuously so portals move when dropdown
   opens/closes in the navbar.

   Now reads leftOpen from LayoutContext internally
   so callers don't need to pass isLeftOpen.
   ═══════════════════════════════════════════ */
export const usePortalTarget = (slotId) => {
  const { leftOpen } = useLayout();
  const navbarSlotId = slotId.replace("-portal-slot", "-navbar-portal-slot");
  const [target, setTarget] = useState(null);

  useEffect(() => {
    const resolve = () => {
      // When sidebar is closed, prefer the navbar slot if it exists
      if (!leftOpen) {
        const navbar = document.getElementById(navbarSlotId);
        if (navbar) return navbar;
      }
      // Fallback to sidebar slot (always exists in DOM even when off-screen)
      return document.getElementById(slotId) || null;
    };

    // Initial resolve
    const el = resolve();
    setTarget(el);

    // Keep polling — the navbar portal slot is conditionally rendered
    // so we need to detect when it appears or disappears
    const interval = setInterval(() => {
      const next = resolve();
      setTarget((prev) => {
        if (prev !== next) return next;
        return prev;
      });
    }, 150);

    return () => clearInterval(interval);
  }, [slotId, navbarSlotId, leftOpen]);

  return target;
};

// Resolves a view's icon string — Lucide key or Font Awesome name
export { feedViewIcon } from "../../../../utils/viewIcons";
